'use strict';

require("core-js/modules/es6.function.name");

module.exports = function ReactNativeFile(_ref) {
  var uri = _ref.uri,
      name = _ref.name,
      type = _ref.type;
  this.uri = uri;
  this.name = name;
  this.type = type;
};